import { createWizard } from '@heidi/flow/wizard';

/**
 * The dictate onboarding step flow. Declaration order is the forward order —
 * note `key-confirm` deliberately precedes `key-selection`: the default-key
 * confirmation is the linear path, and "change key" branches into
 * `key-selection` via `goToStep`.
 *
 * - `try-dictation` is reachable by branching, so its Back returns to
 *   `key-confirm` (the linear anchor), not to wherever the user came from.
 * - Post-auth steps (`sign-in` onward, except the final step) suppress Back —
 *   the user must not walk back out of the authenticated stretch.
 * - `tone` is always in the linear post-auth path (`release-dictation-tone-settings`
 *   shipped 100%).
 */
export const dictateOnboardingWizard = createWizard({
  id: 'dictateOnboarding',
  steps: [
    { id: 'permissions', canGoBack: false },
    { id: 'key-confirm' },
    { id: 'key-selection' },
    { id: 'try-dictation', backTarget: 'key-confirm' },
    { id: 'sign-in', canGoBack: false },
    { id: 'about-you', canGoBack: false },
    { id: 'languages', canGoBack: false },
    { id: 'tone', canGoBack: false },
    { id: 'ready-to-dictate' },
  ],
});

/** The step-id union — single source of truth is the wizard's declared steps. */
export type DictateStep = (typeof dictateOnboardingWizard.stepIds)[number];
